module.exports = __webpack_public_path__ + "ux-design.svg?f686fa5aa16ae00a09973abce5316395";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ux-design.svg
// module id = 127
// module chunks = 0